import { Spinner } from '../../components/Spinner.js';
import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router';
import { apiClient } from '../../lib/api-client.js';

interface Checkin {
  id: string;
  checkinAt: string;
  spot: { id: string; name: string; category: string };
}

export function UserCheckinListView() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [checkins, setCheckins] = useState<Checkin[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    apiClient
      .get<Checkin[]>(`/users/${id}/checkins`)
      .then((data) => {
        if (data) setCheckins(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="p-4 max-w-lg mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-gray-500 hover:text-gray-700"
          aria-label="戻る"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <h1 className="text-xl font-bold">チェックイン履歴</h1>
      </div>

      {loading && (
        <div className="flex justify-center py-8">
          <Spinner />
        </div>
      )}

      {!loading && checkins.length === 0 && (
        <p className="text-center py-8 text-gray-500">チェックイン履歴はありません</p>
      )}

      {!loading && checkins.length > 0 && (
        <div className="bg-white rounded-lg border border-gray-100 divide-y divide-gray-100">
          {checkins.map((checkin) => (
            <Link
              key={checkin.id}
              to={`/spots/${checkin.spot.id}`}
              className="flex justify-between items-center px-4 py-3 text-sm"
            >
              <span className="text-gray-700 truncate flex-1">{checkin.spot.name}</span>
              <span className="text-gray-400 flex-shrink-0 ml-3">
                {new Date(checkin.checkinAt).toLocaleDateString('ja-JP')}{' '}
                {new Date(checkin.checkinAt).toLocaleTimeString('ja-JP', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
